const VERSION_STATUS: boolean = window.location.hostname.search('localhost') === -1;
const BETA_VERSION: boolean = window.location.hostname.search('beta') === -1;
const ARK_VERSION: boolean = window.location.hostname.search('4rk') === -1;
const MOBILE_VERSION: boolean = window.location.hostname.search('192.168.1.85') === -1;

// export const BASE_SITE = 'https://panel.mahi20.4rk.ir/';
// export const BASE_SITE = VERSION_STATUS ? 'https://panel.mahi20.4rk.ir/' : 'http://localhost/sanam/';
// export const BASE_SITE = 'https://panel.mahi20.4rk.ir/';
// export const BASE_SITE = 'https://api.dr20.net/';
export const BASE_SITE = VERSION_STATUS && BETA_VERSION && ARK_VERSION && MOBILE_VERSION ? 'https://arzyabmachine.ir/api/' : 'http://api.keshavarzi.koo-chi.ir/';
// const BASE_API = VERSION_STATUS ? 'api/v1/' : 'api/beta/';
const BASE_API = VERSION_STATUS && BETA_VERSION && ARK_VERSION && MOBILE_VERSION ? 'v1/' : 'v1/';

export const API_MAIN = BASE_API + 'main'; 
export const API_CATEGORIES = BASE_API + 'categories'; 
export const API_ALL_CATEGORIES = BASE_API + 'categories/all'; 
export const API_PRODUCTS = BASE_API + 'products'; 
export const API_PRODUCT_DETAILS = BASE_API + 'products/details'; 
export const API_ABOUT_US = BASE_API + 'about-us'; 
export const API_CONTACT_US = BASE_API + 'contact-us'; 
export const SURGURY_CONSULTATION = BASE_API + 'surgury-consultation';